import { render, staticRenderFns } from "./VeterinaryPatientAdd.vue?vue&type=template&id=2c67d352&scoped=true"
import script from "./VeterinaryPatientAdd.vue?vue&type=script&lang=js"
export * from "./VeterinaryPatientAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67d352",
  null
  
)

export default component.exports